import { IUserDynamicControlsParameters, UserDynamicControls } from '../form-controls/user.form-controls';
import { IUser } from '../interfaces/user';

export class UserDynamicControlsPartial extends UserDynamicControls {
    constructor(userPartial?: IUser, additionalParameters?: IUserDynamicControlsParameters) {
        super(userPartial, additionalParameters);
    }
}
